export default {
  en: {
    cannot_attend: 'Cannot attend',
    placeholder: 'Loading ...',
    snackbar: {
      vote: 'Thank you for voting!',
      un_vote: 'Thank you for voting!',
      generic_error_msg:
        'Something went wrong! Please try again later or contact us.',
    },
    votes: {
      zero: '0 votes',
      one: '1 vote',
      other: '%{count} votes',
    },
  },
};
